import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getImage, warrantyExtend } from "../services/Tools";
import { showSnackbar } from "./snackbar";
import warrenty123 from "../assets/warrenty123.png";

const RegisterWarrenty = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const verifiedProduct = location.state?.verifiedProduct || null;
  console.log("verifiedProduct:", verifiedProduct);
  const [submitting, setSubmitting] = useState(false);
  const [isInvoiceUploading, setIsInvoiceUploading] = useState(false);
  const [isProductUploading, setIsProductUploading] = useState(false);
  const [responseInvoiceFile, setResponseInvoiceFile] = useState("");
  const [responseProductFile, setResponseProductFile] = useState("");
  const [errors, setErrors] = useState({});
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [today, setToday] = useState("");
  const [endDate, setEndDate] = useState("");
  const [pincodeError, setPincodeError] = useState("");
  const [loadingPincode, setLoadingPincode] = useState(false);
  const formatDate = (date) => {
    if (!date) return "";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

    const fetchPincodeDetails = async (pincode) => {
      setPincodeError("");
      try {
        setLoadingPincode(true);
        const response = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
        const data = await response.json();
        if (data[0]?.Status === "Success" && data[0].PostOffice?.length > 0) {
          const postOffice = data[0].PostOffice[0];
          setForm((prev) => ({
            ...prev,
            state: postOffice.State,
            city: postOffice.District,
            area: postOffice.Name,
          }));
        } else {
          setPincodeError("Invalid PIN Code");
          setForm((prev) => ({ ...prev, state: "", city: "", area: "" }));
        }
      } catch {
        setPincodeError("Invalid PIN Code");
        setForm((prev) => ({ ...prev, state: "", city: "", area: "" }));
      } finally {
        setLoadingPincode(false);
      }
    };

  const addDays = (date, days) => {
    const result = new Date(date);
    result.setDate(result.getDate() + parseInt(days || 0));
    return result;
  };
  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setToday(today);
    const startDateObj = new Date(today);
    const warrantyDays = verifiedProduct?.warrent_days || 0;
    const endDate = formatDate(addDays(startDateObj, warrantyDays));
    setEndDate(endDate);
  }, [verifiedProduct])

  const [form, setForm] = useState({
    userid: localStorage.getItem("userId") || "",
    orderno: "",
    name: localStorage.getItem("userName") || "",
    email: "",
    mobile: localStorage.getItem("mobile") || "",
    dealername: "",
    pin: "",
    state: "",
    city: "",
    area: "",
    invoiceimage: "",
    productid: "",
    productimage: "",
    startdate: verifiedProduct?.startdate || new Date().toISOString().split("T")[0],
    enddate: "",

    warrantytype: verifiedProduct?.warrent_type || "N/A",
    scratchNumber: verifiedProduct?.scratch_no || "",
    serialnumber:  "",
  });

  useEffect(() => {
    if (form.pin && /^[0-9]{6}$/.test(form.pin)) {
      fetchPincodeDetails(form.pin);
    }
  }, [form.pin]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
    if (name === "pin" && pincodeError) {
      setPincodeError("");
    }
  };

  const uploadImage = async ({ image, filePath, field }) => {
    if (field === "invoiceimage") {
      setIsInvoiceUploading(true);
    } else {
      setIsProductUploading(true);
    }

    try {
      const filename = filePath.split("/").pop();
      const uploadResponse = await getImage({
        filename,
        image,
        userid: form.userid,
        processes: "warranty",
      });

      const imageUrl =
        uploadResponse?.image ||
        uploadResponse?.data?.imageurl ||
        uploadResponse?.imageurl ||
        uploadResponse?.url;

      if (imageUrl) {
        if (field === "invoiceimage") {
          setResponseInvoiceFile(imageUrl);
          setForm((prev) => ({ ...prev, invoiceimage: imageUrl }));
        } else if (field === "productimage") {
          setResponseProductFile(imageUrl);
          setForm((prev) => ({ ...prev, productimage: imageUrl }));
        }
        return imageUrl;
      } else {
        showSnackbar("error", "Image upload failed.");
        return null;
      }
    } catch (error) {
      showSnackbar("error", "Image upload failed.");
      return null;
    } finally {
      if (field === "invoiceimage") {
        setIsInvoiceUploading(false);
      } else {
        setIsProductUploading(false);
      }
    }
  };

  const allowedTypes = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "application/pdf",
  ];

  const handleFileUpload = async (event, field) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (file.size > 2 * 1024 * 1024) {
      showSnackbar("error", "File size should be less than 2MB");
      return;
    }

    if (!allowedTypes.includes(file.type)) {
      showSnackbar("error", "Please upload a JPG, JPEG, PNG, or PDF file");
      return;
    }

    const reader = new FileReader();
    reader.onloadend = async () => {
      const base64 = reader.result;
      await uploadImage({
        image: base64,
        filePath: file.name,
        field,
      });
    };
    reader.readAsDataURL(file);
  };

  const validate = () => {
    const newErrors = {};
    if (!form.orderno) newErrors.orderno = "Invoice No is required";
    if (!form.serialnumber)
      newErrors.serialnumber = "Serial Number is required";
    if (!form.dealername) newErrors.dealername = "Dealer Code is required";
    if (!form.startdate) newErrors.startdate = "Invoice Date is required";
    // if (!responseInvoiceFile)
    //   newErrors.invoiceimage = "Invoice image is required";
    // if (!responseProductFile)
    //   newErrors.productimage = "Warranty card image is required";
    return newErrors;
  };


  const submitWarranty = async (event) => {
    event.preventDefault();
    console.log(" Submit button clicked");

    const validationErrors = validate();
    console.log(" Validation errors:", validationErrors);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      showSnackbar("error", "Please fill all required fields");
      return;
    }

    setSubmitting(true);
    console.log(" Form data:", form);
    console.log(" verifiedProduct:", verifiedProduct);

    const payload = {
      userid: verifiedProduct.userid || form.userid,
      orderno: form.orderno,
      serialnumber: form.serialnumber,
      invoiceimage: responseInvoiceFile,
      productimage: responseProductFile,
      dealername: form.dealername,
      productid: verifiedProduct?.productid,
      category: verifiedProduct?.category,
      modelno: verifiedProduct?.modelno,
      startdate: form.startdate,
      scratchno: verifiedProduct?.scratch_no,
      hologramno: verifiedProduct?.hologram_number,
      enddate: endDate,
      warrantytype: verifiedProduct?.warrent_type || "N/A",
      warrantydays: verifiedProduct?.warrent_days || 0,
      warrantyid: verifiedProduct?.warrent_id || "",
      pin: form.pin,
      state: form.state,
      district: form.city,
      area: form.area,
    };

    try {
      console.log(" Sending payload:", payload);
      const response = await warrantyExtend(payload);
      console.log(" API response:", response);

      if (response) {
        console.log(" Navigating to success page");
        navigate("/warrantysucess");
      } else {
        console.log(" Response was falsy");
        showSnackbar("error", "Something went wrong during warranty submission.");
      }
    } catch (error) {
      console.error(" Submit error:", error);
      showSnackbar("error", "Failed to submit warranty to the server.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="container" style={{ minHeight: "80vh" }}>


      <div className="row justify-content-center">

        <div className="col-md-8">

          <form onSubmit={submitWarranty} className="warranty-form">
            <img
              src={warrenty123}
              alt="Warranty"
              style={{
                width: "100%",
                maxHeight: "1000px",
                objectFit: "contain",
                display: "block",
                margin: "0 auto 20px",
                borderRadius: "8px",
              }}
            />

            {/* <h1 style={{
              color: "#fff",
              backgroundColor: "#005487",
              width: "100%",
              textAlign: "center",
              padding: "15px 0",
              margin: "0 0 20px 0",
              fontSize: "32px",
              fontWeight: "700",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
            }}>
              Pixel Tools
            </h1> */}
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">
                  Invoice No <span className="required">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.orderno ? "is-invalid" : ""}`}
                  name="orderno"
                  value={form.orderno}
                  onChange={handleChange}
                  placeholder="Enter invoice number"
                />
                {errors.orderno && (
                  <div className="invalid-feedback">{errors.orderno}</div>
                )}
              </div>
              <div className="form-group">
                <label className="form-label">
                  Invoice Date <span className="required">*</span>
                </label>
                <input
                  type="date"
                  className={`form-control ${errors.startdate ? "is-invalid" : ""}`}
                  name="startdate"
                  value={form.startdate}
                  onChange={handleChange}
                  max={today}
                />
                {errors.startdate && (
                  <div className="invalid-feedback">{errors.startdate}</div>
                )}
              </div>

              <div className="form-group">
                <label className="form-label">
                  End Date 
                </label>
                <input
                  type="date"
                  // className={`form-control ${errors.enddate ? "is-invalid" : ""}`}
                  name="enddate"
                  value={endDate}
                  readOnly
                  // onChange={handleChange}
                  max={today}
                />
                {errors.enddate && (
                  <div className="invalid-feedback">{errors.enddate}</div>
                )}
              </div>

              <div className="form-group">
                <label className="form-label">
                  Serial Number <span className="required">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.serialnumber ? "is-invalid" : ""}`}
                  name="serialnumber"
                  value={form.serialnumber}
                  onChange={handleChange}
                  placeholder="Enter product serial number"
                />
                {errors.serialnumber && (
                  <div className="invalid-feedback">
                    {errors.serialnumber}
                  </div>
                )}
              </div>
              <div className="form-group">
                <label className="form-label">
                  Dealer Code / Name <span className="required">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.dealername ? "is-invalid" : ""}`}
                  name="dealername"
                  value={form.dealername}
                  onChange={handleChange}
                  placeholder="Enter dealer code or name"
                />
                {errors.dealername && (
                  <div className="invalid-feedback">
                    {errors.dealername}
                  </div>
                )}
              </div>

              <div className="form-group">
                <label className="form-label">
                  Pincode
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="pin"
                  value={form.pin}
                  onChange={handleChange}
                  placeholder="Enter 6 digit pincode"
                  maxLength={6}
                />
                {loadingPincode && (
                  <div style={{ fontSize: "12px", color: "#005487", marginTop: "4px" }}>
                    Fetching details...
                  </div>
                )}
                {pincodeError && (
                  <div className="invalid-feedback" style={{ display: "block" }}>
                    {pincodeError}
                  </div>
                )}
              </div>

              <div className="form-group">
                <label className="form-label">
                  State
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="state"
                  value={form.state}
                  onChange={handleChange}
                  placeholder="State"
                />
              </div>

              <div className="form-group">
                <label className="form-label">
                  City/District
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="city"
                  value={form.city}
                  onChange={handleChange}
                  placeholder="District"
                />
              </div>

              <div className="form-group">
                <label className="form-label">
                  Area/Locality
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="area"
                  value={form.area}
                  onChange={handleChange}
                  placeholder="Auto-filled from pincode"
                />
              </div>

              <div className="form-group form-group-full">
                <label className="form-label">Warranty Type ( Days )</label>
                <input
                  type="text"
                  className="form-control"
                  name="warrantytype"
                  value={form.warrantytype || "N/A"}
                  readOnly
                />
              </div>

              <div className="form-group">
                <label className="form-label">
                  Upload Invoice (max 2Mb)
                </label>
                <div className="file-input-wrapper">
                  <input
                    type="file"
                    id="invoiceFile"
                    accept="image/*"
                    onChange={(e) => handleFileUpload(e, "invoiceimage")}
                    disabled={isInvoiceUploading}
                  />
                  <label htmlFor="invoiceFile" className="file-input-label">
                    <span>
                      {form.invoiceimage
                        ? "Invoice uploaded"
                        : "Click to upload invoice image"}
                    </span>
                  </label>
                </div>
                {isInvoiceUploading && (
                  <div className="file-uploading">
                    <span className="spinner-border spinner-border-sm"></span>
                    Uploading invoice image...
                  </div>
                )}
                {responseInvoiceFile && !isInvoiceUploading && (
                  <div className="file-preview">
                    <div className="file-name">✓ Invoice image uploaded successfully</div>
                    <img
                      src={responseInvoiceFile}
                      alt="Invoice"
                      style={{
                        width: "180px",
                        height: "180px",
                        objectFit: "cover",
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                        marginTop: "10px",
                      }}
                    />
                  </div>
                )}
                {errors.invoiceimage && (
                  <div className="invalid-feedback">
                    {errors.invoiceimage}
                  </div>
                )}
              </div>
              <div className="form-group">
                <label className="form-label">
                  Upload Warranty Card (max 2Mb)
                </label>
                <div className="file-input-wrapper">
                  <input
                    type="file"
                    id="productFile"
                    accept="image/*"
                    onChange={(e) => handleFileUpload(e, "productimage")}
                    disabled={isProductUploading}
                  />
                  <label htmlFor="productFile" className="file-input-label">
                    <span>
                      {form.productimage
                        ? "Warranty card uploaded"
                        : "Click to upload warranty card"}
                    </span>
                  </label>
                </div>
                {isProductUploading && (
                  <div className="file-uploading">
                    <span className="spinner-border spinner-border-sm"></span>
                    Uploading warranty card...
                  </div>
                )}
                {responseProductFile && !isProductUploading && (
                  <div className="file-preview">
                    <div className="file-name">✓ Warranty card uploaded successfully</div>
                    <img
                      src={responseProductFile}
                      alt="Warranty Card"
                      style={{
                        width: "180px",
                        height: "180px",
                        objectFit: "cover",
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                        marginTop: "10px",
                      }}
                    />
                  </div>
                )}
                {errors.productimage && (
                  <div className="invalid-feedback">
                    {errors.productimage}
                  </div>
                )}
              </div>
            </div>

            <div
              style={{
                marginTop: "20px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                flexWrap: "wrap",
              }}
            >
              <input
                type="checkbox"
                id="acceptTerms"
                checked={acceptTerms}
                onChange={(e) => setAcceptTerms(e.target.checked)}
              />
              <label htmlFor="acceptTerms" style={{ margin: 0 }}>
                I agree to the{" "}
                <span
                  onClick={() => setShowTerms(true)}
                  style={{
                    color: "#0d6efd",
                    cursor: "pointer",
                    textDecoration: "underline",
                    fontWeight: "600",
                  }}
                 >
                  Terms & Conditions
                </span>
              </label>
            </div>

            {showTerms && (
              <div
                style={{
                  position: "fixed",
                  inset: 0,
                  background: "rgba(0,0,0,0.5)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 9999,
                }}
              >
                <div
                  style={{
                    width: "90%",
                    maxWidth: "700px",
                    background: "#fff",
                    borderRadius: "10px",
                    padding: "25px",
                    maxHeight: "80vh",
                    overflowY: "auto",
                  }}
                >
                  <h3>Terms & Conditions</h3>
                  <div style={{ marginTop: "15px" }}>
                    <p>
                      The following terms and conditions apply to all warranty claims for Pixel Tools products.
                       Please read them carefully before submitting your warranty request.
                    </p>
                    <ol
                      style={{
                        paddingLeft: "20px",
                        lineHeight: "1.8",
                        color: "#444",
                        fontSize: "15px",
                      }}
                    >
                      <li>Valid Purchase Invoice — A valid purchase invoice is mandatory for all warranty claims.</li>
                      <li>Warranty Card — The warranty card must be completely filled with accurate customer details, product details, seller details, and the seller's official seal.</li>
                      <li>Warranty Product Registration — The product must be registered on the Pixel Tools website using a valid dealer code.</li>
                      <li>Correct Information — All information provided during warranty registration must be accurate and complete.</li>
                      <li>Warranty Verification — Warranty will be activated only after successful verification of the product details registered on the Pixel Tools website.</li>
                      <li>Required Documents — All documents submitted must be clear, complete, and readable.</li>
                      <li>Warranty Period — The warranty is valid only for the period specified for the product.</li>
                      <li>Warranty Start Date — The warranty period starts from the purchase date mentioned on the original invoice.</li>
                      <li>Normal Operating Conditions — Warranty is applicable only when the product is used under normal operating conditions.</li>
                      <li>Manufacturing Defects — The warranty covers only manufacturing defects confirmed by Pixel Tools.</li>
                      <li>Charges Not Covered — Transportation, installation, inspection, service charges are not covered under warranty.</li>
                      <li>Product Instructions — The product must be used according to the user manual and operating instructions.</li>
                      <li>Correct Accessories — Only genuine accessories recommended by Pixel Tools should be used.</li>
                      <li>Unauthorized Repairs — Repairs or servicing must be carried out only by Pixel Tools authorized service centers.</li>
                      <li>Product Modifications — Any modification, alteration, or tampering with the product is strictly prohibited.</li>
                      <li>Cosmetic & Non-Functional Damage — Cosmetic damages are not covered under warranty.</li>
                      <li>External Damage — Damage caused by fire, water, dust, chemicals, misuse, negligence is not covered.</li>
                      <li>Mishandling & Misuse — Any damage caused due to mishandling, negligence, abuse will void the warranty.</li>
                      <li>Original Invoice Requirement — Warranty claims accepted only upon submission of the original purchase invoice.</li>
                      <li>Claim Verification — The Pixel Tools Customer Support Team may contact the customer up to two times to verify warranty details.</li>
                      <li>Warranty Approval — All warranty requests are subject to inspection and approval by the Pixel Tools Service Team.</li>
                    </ol>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => setShowTerms(false)}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}

            <div className="text-center mt-4">
              <button
                type="submit"
                className="btn btn-warranty-submit"
                disabled={
                  submitting || !acceptTerms
                }
              >
                {submitting ? (
                  <span className="button-loading">
                    <span className="spinner-border spinner-border-sm"></span>
                    Submitting...
                  </span>
                ) : (
                  "Submit Warranty Extension"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RegisterWarrenty;
